import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { sendPasswordResetEmail } from '@/lib/api'
import { getErrorMessage } from '@/lib/error-messages'

export function ForgotPasswordPage() {
    const [email, setEmail] = useState('')
    const [isSubmitted, setIsSubmitted] = useState(false)

    const resetMutation = useMutation({
        mutationFn: async () => {
            await sendPasswordResetEmail(email.trim().toLowerCase())
        },
        onSuccess: () => {
            setIsSubmitted(true)
            toast.success('Reset-Link wurde an deine E-Mail gesendet.')
        },
        onError: (error) => {
            toast.error(getErrorMessage(error))
        },
    })

    if (isSubmitted) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
                <Card className="w-full max-w-md">
                    <CardHeader className="items-center text-center">
                        <img src="/motionlab.png" alt="motionLAB Logo" className="h-24 w-auto object-contain" />
                        <CardTitle>E-Mail gesendet</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4 text-center">
                        <p className="text-muted-foreground">
                            Wir haben dir einen Link zum Zurücksetzen deines Passworts an <strong>{email}</strong> gesendet.
                        </p>
                        <p className="text-sm text-muted-foreground">
                            Bitte überprüfe auch deinen Spam-Ordner.
                        </p>
                        <Button asChild className="w-full">
                            <Link to="/login">Zurück zum Login</Link>
                        </Button>
                    </CardContent>
                </Card>
            </div>
        )
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="items-center text-center">
                    <img src="/motionlab.png" alt="motionLAB Logo" className="h-24 w-auto object-contain" />
                    <CardTitle>Passwort vergessen</CardTitle>
                </CardHeader>
                <CardContent>
                    <form
                        className="space-y-4"
                        onSubmit={(event) => {
                            event.preventDefault()
                            resetMutation.mutate()
                        }}
                    >
                        <div className="space-y-2">
                            <Label htmlFor="email">E-Mail</Label>
                            <Input
                                id="email"
                                type="email"
                                placeholder="deine@email.de"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        {resetMutation.isError && (
                            <Alert variant="destructive">
                                <AlertDescription>{getErrorMessage(resetMutation.error)}</AlertDescription>
                            </Alert>
                        )}

                        <Button
                            type="submit"
                            className="w-full"
                            disabled={resetMutation.isPending}
                        >
                            {resetMutation.isPending ? 'Wird gesendet...' : 'Link senden'}
                        </Button>

                        <p className="text-center text-sm text-muted-foreground">
                            <Link className="text-primary underline" to="/login">
                                Zurück zum Login
                            </Link>
                        </p>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
